// extracted by mini-css-extract-plugin
module.exports = {"seoContent":"seo-content_seoContent__13sNj"};